import { en } from '../translations';
import { APP_VERSION } from './Configs';
import { LocalStorageService } from '../services/LocalStorageService';

const appVersion = LocalStorageService.get('app_version');
if (parseFloat(appVersion) !== APP_VERSION) {
    LocalStorageService.remove('saved_store_state');
    LocalStorageService.set('app_version', APP_VERSION);
}

const savedState = LocalStorageService.get('saved_store_state');

export const initialState = savedState ? savedState : {
    intl: en,
    user: {
        isLoggedIn: false,
        isLoading: false,
        firstName: null,
        lastName: null,
        email: null,
        mobileNumber: null,
        affiliateId: null,
        error: "",
    },
    verification: {
        code: 0,
        email: {
            verified: false,
            inProcess: false,
            resendVerificationCodeInProcess: false,
            error: []
        },
        mobile: {
            verified: true,
            inProcess: false,
            resendVerificationCodeInProcess: false,
            error: []
        }
    },
    affiliates: {
        allAffiliates: {
            Affiliates: {},
            affiliatesInfo: {}
        },
        permissions: [],
        status: null,
        commissions: {},
        mainTreeData: [],
        allowedSubAff: []
    },
    withdraw: {
        details: []
    }

};

export default initialState;


// WEBPACK FOOTER //
// ./src/constants/InitialState.js